import React from 'react';
import { Button, Stack, ButtonProps } from '@mui/material';

type Props = {
  onApprove: () => void;
  onReject: () => void;
  onReturn?: () => void;
  approveDisabled?: boolean;
  rejectDisabled?: boolean;
  returnDisabled?: boolean;
  size?: ButtonProps['size'];
};

const ApproveRejectButtons: React.FC<Props> = ({ onApprove, onReject, onReturn, approveDisabled, rejectDisabled, returnDisabled, size = 'small' }) => {
  return (
    <Stack direction="row" spacing={1}>
      {onReturn ? (
        <Button
          variant="outlined"
          color="warning"
          size={size}
          onClick={onReturn}
          disabled={!!returnDisabled}
          sx={{
            padding: '2px 10px',
            minHeight: 18,
            borderColor: 'warning.main',
            color: 'warning.main',
            backgroundColor: '#ffffff',
            '&:hover': { borderColor: 'warning.dark', backgroundColor: '#ffffff' },
          }}
        >
          Revert Back
        </Button>
      ) : null}
      <Button
        variant="outlined"
        color="error"
        size={size}
        onClick={onReject}
        disabled={!!rejectDisabled}
        sx={{
          padding: '2px 10px',
          minHeight: 18,
          borderColor: 'error.main',
          color: 'error.main',
          backgroundColor: '#ffffff',
          '&:hover': { borderColor: 'error.dark', backgroundColor: '#ffffff' },
        }}
      >
        Reject
      </Button>
      <Button
        variant="outlined"
        color="success"
        size={size}
        onClick={onApprove}
        disabled={!!approveDisabled}
        sx={{
          padding: '2px 10px',
          minHeight: 18,
          borderColor: 'success.main',
          color: 'success.main',
          backgroundColor: '#ffffff',
          '&:hover': { borderColor: 'success.dark', backgroundColor: '#ffffff' },
        }}
      >
        Approve
      </Button>
    </Stack>
  );
};

export default ApproveRejectButtons;
